export let enter = node => node.skip
